import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-start-layout',
  templateUrl: './start-layout.component.html',
  styleUrls: ['./start-layout.component.scss'],
})
export class StartLayoutComponent implements OnInit {

  language$ = this.languageService.language$;
  language: string;

  constructor(private languageService: LanguageService, private accountService: AccountService, private router: Router) {}

  ngOnInit(): void {
    this.language$.subscribe(lng => this.language = lng.toUpperCase())
  }

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

  isActivePage(pageName): boolean {
    const currentPath = window.location.href.split('/').pop();
    return currentPath.startsWith(pageName);
  }

  logout() {
    this.accountService.logout();
    this.router.navigateByUrl('/registration/login')
  }

}
